import Base from "./Base"
import EditBase from "./EditBase"
class DrawBase extends Base {

    constructor(options) {
        super(options);
        options = options || {};
        this.callback = options.callback; //绘制完成后回调
        this.canEdit = options.canEdit || false; //是否可以编辑
        this.callbackEdit = options.callbackEdit || (() => { console.log('开始编辑'); }); //编辑回调
        this.editHelp = null;//编辑辅助类
        this.plot = null;//标绘数据
        this.entities = []; //脏数据
        this.positionsTemp = [];//所有点
        this.positions = [];//关键点
        this.isStarted = false;//是否开始编辑
        this.lastLeftClickTime = 0; //防止双击事件触发单击事件

        this.hasHeight = options.hasHeight == false ? false : true;
        this.typeName = options.typeName; //中文类型名称
        this.extType = options.extType;
    }


    getEditInterface() {
        return EditBase;
    }

    getTypeName() {
        return "基础图元";
    }

    getType() {
        return "base";
    }

    calculateKeyPositions() {
        this.positions = this.positionsTemp;
    }

    checkLeftClick() {
        return true;
    }

    checkMouseMove() {
        if (this.positionsTemp.length < 1) {
            return false;
        }
        return true;
    }

    checkRightClick() {
        return true;
    }

    leftClick(evt) {

        var $this = this;
        if (!$this.checkLeftClick()) {
            return;
        }
        var cartesian = this.getCatesian3FromPX(evt.position);
        if (!cartesian) {
            return;
        }
        if ($this.positionsTemp.length == 0) {
            $this.positionsTemp.push(cartesian.clone());
        }

        $this.positionsTemp.push(cartesian);
        return cartesian;
    }

    mouseMove(evt) {
        var $this = this;
        if (!$this.checkMouseMove()) {
            return;
        }
        var cartesian = $this.getCatesian3FromPX(evt.endPosition);
        if (!cartesian) {
            return;
        }
        if ($this.isStarted && !$this.Cesium.defined($this.plot)) {
            $this.plot = $this.createPlot();
            $this.entities.push($this.plot);
            if ($this.canEdit) {
                $this.initEditor(); //初始化编辑器
            }
        }

        //--钳击箭头有bug
        // var a = $this.cartesianToLatlng($this.positionsTemp.slice(-1)[0]);
        // var b = $this.cartesianToLatlng(cartesian);
        // if ($this.distance(a, b) < 0.000003) {
        //     return;
        // }
        if ($this.plot) {
            $this.positionsTemp.pop();
            $this.positionsTemp.push(cartesian);
        }
    }

    rightClick() {
        var $this = this;

        if (!$this.checkRightClick()) {
            return;
        }

        if ($this.canEdit) {
            $this.initEditProperty();
            $this.editHelp.initAttrPlot($this.plot);
            $this.editHelp.enableEdit();
            //$this.editHelp.showEdit();
            $this.editHelp.start();
            this.entities.push(...this.editHelp.entities); //记录实体
        }

        $this.stop();
    }

    initEditor() {
        //初始化编辑器
        var $this = this;
        var Editor = $this.getEditInterface();
        $this.editHelp = new Editor({ drawBase: $this, hasHeight: $this.hasHeight }); //初始化编辑类
        if (this.callbackEdit) {
            $this.editHelp.activeEditEventOn(this.callbackEdit);
        }
    }

    //含有此属性对象即可满足编辑条件
    initEditProperty() {
        this.plot.attrPlot = {
            edit_positions: this.positions.slice()
        }; //标绘标识
    }

    createPlot() {

        var entity = this.createEnity();
        this.addDynamicGraph(entity);
        this.viewer.entities.add(entity);
        entity.extTag = "BH_Feature"; //添加类型标识
        entity.extType = this.extType || this.getType();
        entity.typeName = this.typeName || this.getTypeName();

        //TODO：...
        if (this.hasHeight && entity.polygon) {
            entity.polygon.extrudedHeight = 0;
        }

        return entity;

    }

    addDynamicGraph(entity) {

    }

    loadPlot(data) {
        console.log("22222")
        var entity = this.createEnityById(data.markId);

        this.viewer.entities.add(entity);
        entity.extTag = "BH_Feature"; //添加类型标识
        entity.extType = this.extType || this.getType();
        entity.typeName = data.extType || this.getTypeName();
        entity.markName = data.markName;

        this.loadDynamicGraph(entity, data);
        this.initEditor();
        this.startEdit(entity, data);
        return entity;

    }

    startEdit(entity, data) {
        var $this = this;
        $this.plot = entity;
        $this.positions = JSON.parse(data.editPositions);
        $this.initEditProperty();
        $this.editHelp.initAttrPlot($this.plot);
        $this.editHelp.enableEdit();
        // $this.editHelp.showEdit(); 
        //推演标绘
        if(!data.BQ){
            $this.editHelp.start(false);
        }
        
        //普通标绘
        if(data.BQ){
            $this.editHelp.start(false);
        }
    }
    enableEdit(boolean){
        if(this.editHelp){
            this.editHelp.start(boolean);
        }
    }
    disableEdit(boolean){
        if(this.editHelp){
            this.editHelp.stop(boolean);
        }
    }
    loadDynamicGraph(entity, data) {

    }

    start(options) {

        options = options || {};
        this.options = { ...this.options, ...options };
        if (this.isStarted) {
            return;
        }
        var $this = this;
        this.handler = new this.Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);

        this.handler.setInputAction((e) => {
            var now = new Date().getTime();
            if (now - $this.lastLeftClickTime >= 300) {
                $this.leftClick(e)
            }
            $this.lastLeftClickTime = now;
        }, $this.Cesium.ScreenSpaceEventType.LEFT_CLICK);
        this.handler.setInputAction((e) => $this.mouseMove(e), $this.Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        this.handler.setInputAction((e) => $this.rightClick(e), $this.Cesium.ScreenSpaceEventType.RIGHT_CLICK);

        this.isStarted = true;
    }

    stop() {
        this.plot.isPlotflag = this.isPlotflag;
        console.log(this.plot)
        this.callback && this.callback(this.plot);
        this.isStarted = false;
        this.destroy();

        //不需要编辑，属性静态化
        if (!this.canEdit) {
            this.setConstantProperty();
        }
    }

    //属性修改
    setConstantProperty() {

    }

    destroy() {
        if (this.handler) {
            this.handler.destroy();
            this.handler = null;
        }
    }

    reset() {
        this.editHelp = null;//编辑辅助类
        this.plot = null;//标绘数据
        this.positionsTemp = [];//所有点
        this.positions = [];//关键点
        this.isStarted = false;//是否开始编辑
        this.lastLeftClickTime = 0; //防止双击事件触发单击事件
    }

    clear() {

        for (var i = 0; i < this.entities.length; i++) {
            this.viewer.entities.remove(this.entities[i]);
        }
        this.entities.length = 0;

        if (this.canEdit && this.editHelp) {
            this.editHelp.clear();
            this.editHelp.stop();
        }
    }

    toJson() {

    }

    toGeoJson() {

    }
}

export default DrawBase;